// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/entity.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/entity.proto.
 */
export const file_inventory_v1_entity: GenFile = /*@__PURE__*/
  fileDesc("ChlpbnZlbnRvcnkvdjEvZW50aXR5LnByb3RvEgxpbnZlbnRvcnkudjEiTgoTQ29tcGFueU9yRW5nYWdlbWVudBIUCgpjb21wYW55X2lkGAEgASgJSAASFwoNZW5nYWdlbWVudF9pZBgCIAEoCUgAQggKBmVudGl0eUKzAQoQY29tLmludmVudG9yeS52MUILRW50aXR5UHJvdG9QAVpBZ2l0aHViLmNvbS9sZW1hLmFpL2xlbW1hdGEvYXBpL3Byb3RvL2dlbi9pbnZlbnRvcnkvdjE7aW52ZW50b3J5djGiAgNJWFiqAgxJbnZlbnRvcnkuVjHKAgxJbnZlbnRvcnlcVjHiAhhJbnZlbnRvcnlcVjFcR1BCTWV0YWRhdGHqAg1JbnZlbnRvcnk6OlYxYgZwcm90bzM");

/**
 * @generated from message inventory.v1.CompanyOrEngagement
 */
export type CompanyOrEngagement = Message<"inventory.v1.CompanyOrEngagement"> & {
  /**
   * @generated from oneof inventory.v1.CompanyOrEngagement.entity
   */
  entity: {
    /**
     * @generated from field: string company_id = 1;
     */
    value: string;
    case: "companyId";
  } | {
    /**
     * @generated from field: string engagement_id = 2;
     */
    value: string;
    case: "engagementId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message inventory.v1.CompanyOrEngagement.
 * Use `create(CompanyOrEngagementSchema)` to create a new message.
 */
export const CompanyOrEngagementSchema: GenMessage<CompanyOrEngagement> = /*@__PURE__*/
  messageDesc(file_inventory_v1_entity, 0);

